export default __webpack_public_path__ + "static/media/harry-styles.b47ba857.mp3";